<template>
  <div v-if="!isConsentGiven" class="cookie-banner">
    <p>
      Para melhorar a sua experiência na plataforma e prover serviços personalizados, utilizamos cookies.
      &nbsp;Ao aceitar, você terá acesso a todas as funcionalidades do site.
      &nbsp;Para escolher quais quer autorizar, clique em "Definir Cookies".
      &nbsp;Saiba mais em nossa Declaração de Cookies.
    </p>
    <div class="btn-actions">
      <button class="btn-define"
        data-toggle="modal"
        data-target="#cookieSettingsModal">
        Definir Cookies</button>
      <button class="btn-accept" @click="acceptCookies">Aceitar Cookies</button>
    </div>
    <!-- modal -->
    <CookieConsentSettings></CookieConsentSettings>
  </div>
</template>

<script>
import CookieConsentSettings from "./CookieConsentSettings.vue";

export default {
  name: "CookieConsentBanner",
  components: { CookieConsentSettings },
  data() {
    return {
      isConsentGiven: false,
      showModal: false,
    };
  },
  mounted() {
    if (localStorage.getItem("allCookiesAccepted") || localStorage.getItem("onlyEssentialAccepted")) {
      this.isConsentGiven = true;
    }
  },
  methods: {
    async acceptCookies() {
      localStorage.setItem("allCookiesAccepted", "true");
      this.isConsentGiven = true;
    },

    /*     async defineCookies() {
      console.log('AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA');
      /* await this.$nextTick();
      this.showModal = true;
    }, */

    async acceptSettings() {
      this.showModal = false;
      await this.$nextTick();
      if (localStorage.getItem("allCookiesAccepted") || localStorage.getItem("onlyEssentialAccepted")) {
        this.isConsentGiven = true;
      }
    },
  },
};
</script>

<style lang="scss">
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  color: #5e5e5e;
  padding: 1rem;
  text-align: left;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border: 1px solid #5e5e5e;

  .btn-actions {
    display: flex;
    justify-content: right;
    gap: 2rem;
    padding-right: 30px;

    .btn-define {
      border-radius: 30px;
      border: 2px solid #6087bc;
      color: #6087bc;
      background: #fff;
      padding: 0.5rem 1rem;
      cursor: pointer;
    }

    .btn-accept {
      border-radius: 30px;
      border: none;
      color: #fff;
      background: #6087bc;
      padding: 0.5rem 1rem;
      cursor: pointer;
    }
  }
}
</style>
